import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';
import { useSubtleIcon } from 'kineticUtils/styles';

const usePreferencesMenuStyles = makeStyles(({ palette, spacing }) => {
  const { subtleIcon } = useSubtleIcon(palette);
  return createStyles({
    subtleIcon,
    icon: {
      marginRight: spacing(),
    },
    menuItem: {
      width: 260,
    },
    editingMenuItem: {
      overflow: 'visible',
      // cant override focusVisible class, force no bg color when editing
      backgroundColor: 'transparent !important',
    },
    editableWrapper: {
      maxWidth: 230,
    },
    contextMenu: {
      padding: 0,
    },
    defaultIcon: {
      marginLeft: spacing(2),
    },
  });
});

export default usePreferencesMenuStyles;
